"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _LazyImage = _interopRequireDefault(require("./components/LazyImage"));
var _isNativeLazyLoadingSupported = _interopRequireDefault(require("../../utils/isNativeLazyLoadingSupported"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Image = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var lazyLoading = props.lazyLoading,
    thumbnail = props.thumbnail,
    thumbnailSrc = props.thumbnailSrc,
    withPlaceholder = props.withPlaceholder,
    _a = props.useNativeLazyLoading,
    useNativeLazyLoading = _a === void 0 ? false : _a,
    _b = props.loadingEffect,
    loadingEffect = _b === void 0 ? 'blur' : _b,
    _c = props.transitionDuration,
    transitionDuration = _c === void 0 ? 1 : _c,
    _d = props.observerOptions,
    observerOptions = _d === void 0 ? {} : _d,
    filteredProps = __rest(props, ["lazyLoading", "thumbnail", "thumbnailSrc", "withPlaceholder", "useNativeLazyLoading", "loadingEffect", "transitionDuration", "observerOptions"]);
  return lazyLoading ? useNativeLazyLoading && _isNativeLazyLoadingSupported.default ? (0, _jsxRuntime.jsx)("img", __assign({
    ref: ref
  }, filteredProps, {
    loading: 'lazy'
  })) : (0, _jsxRuntime.jsx)(_LazyImage.default, __assign({
    ref: ref
  }, filteredProps, {
    thumbnail: thumbnail,
    thumbnailSrc: thumbnailSrc,
    withPlaceholder: withPlaceholder,
    loadingEffect: loadingEffect,
    transitionDuration: transitionDuration,
    observerOptions: observerOptions
  })) : (0, _jsxRuntime.jsx)("img", __assign({
    ref: ref
  }, filteredProps));
});
Image.displayName = 'Image';
var _default = Image;
exports.default = _default;